import { OutlierTimeOption } from '@amzn/aet-dynamo-kit';
import { TypedDocumentNode, gql } from '@apollo/client';
import { RawOutlier } from './schema';

export type GetOutliersForManagerVariables = {
  managerAlias: string;
  isOm: boolean;
  timeOption: OutlierTimeOption;
  timestamps: string[];
};

export type GetOutliersForManagerResponse = {
  getOutliersForManager: RawOutlier[];
};

export const getOutliersForManagerQuery: TypedDocumentNode<
  GetOutliersForManagerResponse,
  GetOutliersForManagerVariables
> = gql`
  query GetOutliersForManager(
    $managerAlias: String!
    $isOm: Boolean!
    $timeOption: OutlierTimeOption!
    $timestamps: [String!]!
  ) {
    getOutliersForManager(
      managerAlias: $managerAlias
      isOm: $isOm
      timeOption: $timeOption
      timestamps: $timestamps
    ) {
      userID
      userName
      managerUserName
      category
      isRepeat
      relatedContacts {
        contactID
        status
        exceptionStatus
        justification
      }
    }
  }
`;
